import "@Styles/Global/_forms_sm.less";
import "@Styles/Global/_globalCore_lg.less";
import "@Styles/Global/_globalCore_md.less";
import "@Styles/Global/_globalCore_sm.less";
import "@Styles/Global/_Import/_icons.less";
import "@Styles/Global/_Import/_mixins-usage.less";
import "@Styles/Global/_Import/BC/_mixins.less";
import "@Styles/Global/BC/_fonts.less";
import "@Styles/Global/BC/_globalCore_lg.less";
import "@Styles/Global/BC/_globalCore_sm.less";
import "@Styles/Structure/Footer/_footer_lg.less";
import "@Styles/Structure/Footer/_footer_sm.less";
import "@Styles/Structure/Header/_header_lg.less";
import "@Styles/Structure/Header/_header_sm.less";
import "@Styles/Structure/Header/Pando/_header_lg.less";
import "@Styles/Structure/Header/Pando/_header_sm.less";
import "@Styles/Structure/Footer/BC/_footer_lg.less";
import "@Styles/Structure/Footer/BC/_footer_sm.less";
import "@Styles/Structure/Header/BC/_header_lg.less";
import "@Styles/Structure/Header/BC/_header_sm.less";
import "@Styles/Global/_globalCore_md.less";
import "@Styles/Global/_globalCore_lg.less";
import "@Styles/Global/BC/_globalCore_lg.less";
import "@Styles/Structure/Footer/_footer_lg.less";
import "@Styles/Structure/Header/_header_lg.less";
import "@Styles/Structure/Header/Pando/_header_lg.less";
import "@Styles/Structure/Footer/BC/_footer_lg.less";
import "@Styles/Structure/Header/BC/_header_lg.less";
var cgc = function cgc() {
  return import(
  /* webpackChunkName: 'cgc' */
  '@Shared/ConsumerGeneratedContent/Scripts/consumerGeneratedContent');
};

var cgcRedesign = function cgcRedesign() {
  return import(
  /* webpackChunkName: 'cgcRedesign' */
  '@Shared/ConsumerGeneratedContent/Scripts/consumerGeneratedContentRedesign');
};

var newsletterCta = function newsletterCta() {
  return import(
  /* webpackChunkName: 'newsletterCta' */
  '@Shared/MyAccount/Scripts/_newsletterCta');
};

var thirdPartyScript = function thirdPartyScript() {
  return import(
  /* webpackChunkName: "thirdPartyScript" */
  '../Controls/ThirdPartyScript/thirdPartyScript');
};

var socialAccountLink = function socialAccountLink() {
  return import(
  /* webpackChunkName: "socialAccountLink" */
  '@Shared/MyAccount/Scripts/socialAccountLink');
};

var oneTrust = function oneTrust() {
  return import(
  /* webpackChunkName: "oneTrust" */
  '../Controls/OneTrust/_oneTrust');
};

var socialFeed = function socialFeed() {
  return import(
  /* webpackChunkName: "socialFeed" */
  '../Controls/SocialFeed/socialFeed');
};

var relatedContent = function relatedContent() {
  return import(
  /* webpackChunkName: "relatedContent" */
  '@Shared/relatedContent/Scripts/relatedContent');
}; //temporarily added for demo purposes


import cgcCounts from '@Shared/ConsumerGeneratedContent/Scripts/ratingAndReviewCounts';
import actionToolbar from '@Shared/ActionToolbar/Scripts/actionToolbar';
import userLinks from '../Controls/UserLinks/userLinks';
import searchBox from '@Shared/SearchNX/Scripts/searchBox';
import simpleNav from '../Controls/SimpleNav/simpleNav';
import targetedNav from '@Shared/SimpleNavigation/Scripts/targetedNav';
import channelLinks from "@Shared/Contrib/Scripts/channelLinks";
import heroTemplate from '../Controls/ContentHeader/Templates/heroTemplate';
import featuredContent from '../Controls/ContentBuilder/featuredContent';
import contentList from '@Shared/SearchNx/Scripts/contentList';
import verticalVideoList from '../Controls/ContentBuilder/verticalVideoList';
import browsePath from '../Controls/BrowsePath/browsePath';

(function () {
  GeneralMills.PandoSites.RegisterModules({
    consumerGeneratedContent: cgc,
    consumerGeneratedContentRedesign: cgcRedesign,
    newsletterCta: newsletterCta,
    thirdPartyScript: thirdPartyScript,
    ratingAndReviewCounts: cgcCounts,
    oneTrust: oneTrust,
    actionToolbar: actionToolbar,
    userLinks: userLinks,
    searchBox: searchBox,
    simpleNav: simpleNav,
    targetedNav: targetedNav,
    channelLinks: channelLinks,
    socialAccountLink: socialAccountLink,
    socialFeed: socialFeed,
    heroTemplate: heroTemplate,
    contentList: contentList,
    featuredContent: featuredContent,
    verticalVideoList: verticalVideoList,
    relatedContent: relatedContent,
    //added temporarily for demo purposes
    browsePath: browsePath
  });
})();